import { Bodytext, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding-top: 40px;
  }
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const DescriptionTitle = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 30px;
`

export const DescriptionBody = styled(Bodytext)`
  font-size: 14px;
  line-height: 22px;
`

export const BulletsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0px;
`

export const BulletRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`

export const BulletRowContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const BulletRowContentTitle = styled(Bodytext)`
  font-size: 14px;
  line-height: 22px;
  color: ${style((theme) => theme.colors.stone)};
`

export const BulletRowContentSubTitle = styled(Heading)`
  font-size: 16px;
  line-height: 24px;
`

export const IconContainer = styled.div`
  all: unset;
  background-color: ${style((theme) => theme.colors.ivoryLight)};
  width: 44px;
  height: 44px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
`
